/* eslint-disable react/prop-types */
/* eslint-disable react/display-name */
/* eslint-disable-line react/forbid-prop-types */
import React from "react"
import Head from "next/head"
import Layout from "components/Layout"
import TextPage from "components/Mobile/TextPage"
import { Typography, Box } from "@material-ui/core"

const AboutUsPage = () => (
  <Layout>
    <Head>
      <title>Mission</title>
    </Head>
    <TextPage
      pageTitle="Mission"
      pageContent={
        <Box mt={3} mb={20} px={1}>
          <Typography variant="body1">
            La missione di <i>Badtraveller</i> è quella di fornire gratuitamente alle persone con disabilità o bisogni
            particolari le principali informazioni sull&apos;accessibilità delle strutture recettive e non solo,
            attraverso la condivisione delle proprie esperienze.
          </Typography>
        </Box>
      }
    />
  </Layout>
)

export default AboutUsPage
